var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7752 1.2342C12.4177 0.876701 11.8402 0.876701 11.4827 1.2342L7.00016 5.70753L2.51766 1.22503C2.16016 0.867534 1.58266 0.867534 1.22516 1.22503C0.867656 1.58253 0.867656 2.16003 1.22516 2.51753L5.70766 7.00003L1.22516 11.4825C0.867656 11.84 0.867656 12.4175 1.22516 12.775C1.58266 13.1325 2.16016 13.1325 2.51766 12.775L7.00016 8.29253L11.4827 12.775C11.8402 13.1325 12.4177 13.1325 12.7752 12.775C13.1327 12.4175 13.1327 11.84 12.7752 11.4825L8.29266 7.00003L12.7752 2.51753C13.1235 2.1692 13.1235 1.58253 12.7752 1.2342Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/CloseMenu.349501ec3d99057b10475e2cb4899566.svg";
export { ForwardRef as ReactComponent };